import Rounded from "./Rounded";
import React from "react";
import { useAnimation, motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import Carousel from "./Carousel";

const capacities = ["5,500 MT", "10,000 MT", "7,500 MT", "12,000 MT", "8,000 MT", "18,000 MT"];

export default function Services() {
  const control = useAnimation();
  const [ref, inView] = useInView();

  const variantBuild = (i) => {
    return {
      visible: {
        opacity: 1,
        y: 0,
        transition: { delay: 0.3 * i, duration: 0.5 },
      },
      hidden: { opacity: 0, y: 100 },
    };
  };

  React.useEffect(() => {
    if (inView) {
      control.start("visible");
    } else {
      control.start("hidden");
    }
  }, [control, inView]);

  return (
    <section id="service" className="pt-[73px] bg-gradient-to-br from-[#114F94] to-[#397CC4]">
      <div className="flex flex-col gap-8 sm:pr-8 py-8 px-8">
        <div className="flex flex-col md:flex-row gap-8">
          <div className="flex flex-col w-full" ref={ref}>
            <motion.h2
              animate={control}
              initial="hidden"
              variants={variantBuild(0)}
              className="text-2xl sm:text-3xl text-default font-bold mb-2 sm:mb-4"
            >
              Service
            </motion.h2>
            <motion.div
              animate={control}
              initial="hidden"
              variants={variantBuild(1)}
              className="bg-[#0C377C] h-full p-4 rounded-md shadow-black shadow-md"
            >
              <motion.p
                animate={control}
                initial="hidden"
                variants={variantBuild(2)}
                className="text-default text-[20px] rounded-lg break-words"
              >
                Our services are based on the conditions of the <b>FIOST</b> payload contract.
              </motion.p>
              <motion.div
                animate={control}
                initial="hidden"
                variants={variantBuild(3)}
                className="flex mt-4 gap-4 mb-4 shadow-md shadow-black rounded-lg"
              >
                <div className="text-white rounded-lg bg-gradient-to-b from-[#106FD8]  p-4">
                  <p>
                    What is <b>FIOST?</b>
                  </p>
                  <br />
                  <p>
                    FIOST stands for <b>F</b>ree <b>I</b>n, <b>O</b>ut, <b>S</b>towed, and <b>T</b>rimmed. This shipping
                    term requires the responsibility of the shipper for the loading, stowage, and trimming process. The
                    ship owner is responsible for transport and the consignee for the unloading process.
                  </p>
                </div>
              </motion.div>
            </motion.div>
          </div>

          <div className="flex flex-col w-full" ref={ref}>
            <motion.h2
              animate={control}
              initial="hidden"
              variants={variantBuild(0)}
              className="ml-4 text-3xl text-default font-bold mb-4"
            >
              Barge's Availability
            </motion.h2>
            <motion.div
              animate={control}
              initial="hidden"
              variants={variantBuild(1)}
              className="bg-[#0C377C] h-full text-default px-4 pb-4 rounded-lg shadow-md shadow-black"
            >
              <br />
              <motion.p animate={control} initial="hidden" variants={variantBuild(2)} className="mb-4 text-[20px]">
                Capacities of barge ships (in metric ton):
              </motion.p>
              <div className="grid grid-cols-2 place-items-center w-[300px] mx-auto gap-4 mb-4">
                {capacities.map((cp, index) => (
                  <motion.div key={cp} animate={control} initial="hidden" variants={variantBuild(index + 2)}>
                    <Rounded small={true}>{cp}</Rounded>
                  </motion.div>
                ))}
              </div>
            </motion.div>
            <br />
          </div>
        </div>
        <div className="max-w-[800px] mx-auto">
          <motion.h2
            animate={control}
            initial="hidden"
            variants={variantBuild(0)}
            className="text-2xl text-center sm:text-3xl text-default font-bold mb-2 sm:mb-4"
          >
            Gallery
          </motion.h2>
          <motion.div
            animate={control}
            initial="hidden"
            variants={variantBuild(1)}
            className="h-full flex items-center justify-center bg-black rounded-3xl overflow-hidden"
          >
            <Carousel />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
